module.exports = __webpack_public_path__ + "img/rio-de-janeiro.162fe4e0.jpg";